import React, { Component } from 'react';
import loadScripts from '../../dassets/js/custom';
import api from '../api';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import store from "../redux/store";
import moment from 'moment';
import { Form } from 'react-bootstrap';
import FCalculator from '../custom-components/calculator';
import Calculator from "awesome-react-calculator";
// import qs from 'qs';

class PriceList extends Component {
  constructor(props) {
    super(props);
    this.onChangeDate = this.onChangeDate.bind(this);

    this.state = {
      // allprices: [],
      prices: [], 
      losers: [],
      gainers: [],
      date: moment(new Date()).format("YYYY-MM-DD"),
      filter: 'all',
      docname: ''
    }
  }

  componentDidMount() {
    loadScripts();
    this.fetchLatest();
  }

  delete_cookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  onChangeDate(e) {
    this.setState({
      date: e.target.value
    });
    this.fetchDocs(e.target.value);
  }

  fetchLatest() {
    api.get(`/get/latestpricelist`)
      .then(response => {
        let losers = [], gainers = [];
        response.data.data.forEach(p => {
          if ((p.Close - p.PClose) < 0) {
            losers.push(p)
          } else if (p.Close - p.PClose > 0) {
            gainers.push(p)
          }
        })
        this.setState({
          // allprices: response.data.data,
          prices: response.data.data,
          losers: losers.sort((a, b) => parseFloat(a.SChange) - parseFloat(b.SChange)),
          gainers: gainers.sort((a, b) => parseFloat(b.SChange) - parseFloat(a.SChange)),
          docname: response.data.docname,
          date: moment(response.data.date).format("YYYY-MM-DD")
        });
        this.delete_cookie("pricelist");
      }).catch(error => {
        let err = store.getState().error;
        if (err) {
          toast.error(err.message);
          this.props.history.push(err.redirectUrl)
        }
        console.log(error)
      });
  }

  fetchDocs(date) {
    api.get(`/get/pricelist?date=${date}`)
      .then(response => {
        let losers = [], gainers = [];
        response.data.data.forEach(p => {
          if ((p.Close - p.PClose) < 0) {
            losers.push(p)
          } else if (p.Close - p.PClose > 0) {
            gainers.push(p)
          }
        })
        this.setState({
          // allprices: response.data.data,
          prices: response.data.data,
          losers: losers.sort((a, b) => parseFloat(a.SChange) - parseFloat(b.SChange)),
          gainers: gainers.sort((a, b) => parseFloat(b.SChange) - parseFloat(a.SChange)),
          docname: response.data.docname,
          date: moment(response.data.date).format("YYYY-MM-DD")
        });
        this.delete_cookie("pricelist");
      }).catch(error => {
        let err = store.getState().error;
        if (err) {
          toast.error(err.message);
          this.props.history.push(err.redirectUrl)
        }
        console.log(error)
      });
  }

  priceList(prices) {
    return prices.map((currentprice, i) => {
      return <Price id={i + 1} price={currentprice} key={i} />
    })
  }

  render() {
    return (
      <>
        {/* =================================
    Inner Header */}
        <div className="inner-header bg-light">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
                <h1 className="breadcrumb-title mb-0">Price List</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
                  <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
                  <li className="breadcrumb-item"><span>Research</span></li>
                  <li className="breadcrumb-item"><span>Price List</span></li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* =================================
  Inner Header */}

        {/* =================================
  Tab */}
        <section className="space-pb pt-3">
          <div className="container">

            <div className="row">
              <div className="col-lg-9 grid-margin  stretch-card">
                <div className='row mb-3'>
                  <div className='col-md-4'>
                    <Form.Group>
                      <Form.Control type="date" className="form-control" id="date" placeholder="Date" value={this.state.date} onChange={this.onChangeDate} required />
                      {/* <a to="/prices/create" >Download Price List <i className="mdi mdi-plus"></i> </Link> */}
                    </Form.Group>
                  </div>
                  {/* <div className='col-md-4'>
                  {this.state.prices.length ? <Form.Group>
                                        <select id="filter" required className="form-control" value={this.state.filter} onChange={this.onChangeFilter}>
                                            <option value="" hidden>Select...</option>
                                                <option value="all">All</option>
                                                <option value="gainers">Gainers</option>
                                                <option value="losers">Losers</option>
                                        </select>
                                    </Form.Group> : <></> }
                  </div> */}
                  <div className='col-md-4'>
                    {this.state.prices.length ?
                      <a target={'_blank'} href={`${process.env.REACT_APP_FILE_EXCEL_URL}/documents/${this.state.docname}`} className='btn btn-primary'><i className="mdi mdi-file-download"></i>&nbsp;Download Price List</a> : <></>}
                  </div>
                </div>
                <div className="card">
                  {this.state.prices.length ? <div className="card-body">
                    {/* <h4 className="card-title">Price List</h4> */}
                    <p className="card-description"> Here are the list of the prices for {moment(this.state.date).format("MMM DD, YYYY")}.
                    </p>
                    {this.state.prices.length ?
                      <div className="row">
                        <div className="col-12">
                          <div className="nav mb-2 nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                            <a className="nav-link active" id="v-pills-who-we-are-tab" data-bs-toggle="pill" href="#all" role="tab" aria-controls="v-pills-who-we-are" aria-selected="true">All</a>
                            <a className="nav-link" id="v-pills-our-mission-tab" data-bs-toggle="pill" href="#gainers" role="tab" aria-controls="v-pills-our-mission" aria-selected="false">Gainers</a>
                            <a className="nav-link" id="v-pills-our-vision-tab" data-bs-toggle="pill" href="#losers" role="tab" aria-controls="v-pills-our-vision" aria-selected="false">Losers</a>
                          </div>
                        </div>
                      </div> : <></>}

                    <div className="tab-content" id="v-pills-tabContent">
                      <div className="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="v-pills-who-we-are-tab">
                        <div className="table-responsive mt-2">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                {Object.keys(this.state.prices[0]).map((key, i) => {
                                  return i == 0 ? <th key={i}> {key} </th> : <th key={i} style={{textAlign: "center"}}> {key} </th>
                                })}
                              </tr>
                            </thead>
                            <tbody>
                              {this.priceList(this.state.prices)}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="tab-pane fade show" id="gainers" role="tabpanel" aria-labelledby="v-pills-our-mission-tab">
                        <div className="table-responsive mt-2">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                {Object.keys(this.state.prices[0]).map((key, i) => {
                                  return i == 0 ? <th key={i}> {key} </th> : <th key={i} style={{textAlign: "center"}}> {key} </th>
                                })}
                              </tr>
                            </thead>
                            <tbody>
                              {this.priceList(this.state.gainers)}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="tab-pane fade show" id="losers" role="tabpanel" aria-labelledby="v-pills-our-vision-tab">
                        <div className="table-responsive mt-2">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                {Object.keys(this.state.prices[0]).map((key, i) => {
                                  return i == 0 ? <th key={i}> {key} </th> : <th key={i} style={{textAlign: "center"}}> {key} </th>
                                })}
                              </tr>
                            </thead>
                            <tbody>
                              {this.priceList(this.state.losers)}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div> : <div className="card-body"><p className="card-description">There is no price list for {moment(this.state.date).format("MMM DD, YYYY")}.</p></div>}
                </div>
              </div>
              <div className="col-lg-3 grid-margin  stretch-card">
                <div className="row mb-4">
                    <div className="col-12 grid-margin stretch-card">
                  <FCalculator></FCalculator>
                </div>
                </div>
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                <div style={{
                  height: '24rem'
                }}>
                   <Calculator></Calculator> 
                </div></div></div>
              </div>
            </div>
          </div>
        </section>
        {/* =================================
  Tab */}
      </>
    );
  }
}

const Price = props => (
  <tr>
    {props.price ? Object.values(props.price).map((value, i) => {
      return i == 0 ? <td key={i}> {value} </td> : <td key={i} style={{textAlign: "center"}}> {value} </td>
    }) : <></>}
  </tr>
)


export default PriceList;